import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = "/api";
export const resourcesApi = createApi({
  reducerPath: "resources",
  baseQuery: fetchBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    GetAllResources: builder.query({
      query: () => ({
        url: `/resources`,
        method: "GET",
      }),
      providesTags: ["Resources"],
      invalidatesTags: ["Resources", "Resource"],
    }),
    saveResources: builder.mutation({
      query: (data) => ({
        url: `/resources`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Resources"],
    }),
    updateResources: builder.mutation({
      query: ({ id, data }) => ({
        url: `/resources/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Resources"],
    }),
    DeleteResources: builder.mutation({
      query: (id) => ({
        url: `/resources/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Resources"],
    }),
  }),
});

export const {
  useGetAllResourcesQuery,
  useSaveResourcesMutation,
  useDeleteResourcesMutation,
  useUpdateResourcesMutation,
} = resourcesApi;
